import React from 'react';

import AddToCart from './AddToCart';
import Outline from './Outline';
import OutOfStock from './OutOfStock';
import Primary from './Primary';
import SeeDetails from './SeeDetails';
import View3D from './View3D';
import Link from './Link';
import GoBack from './GoBack';
import GoBackSmall from './GoBackSmall';
import ExploreAllDeals from './ExploreAllDeals';
import OutlineButtonV2 from './OutlineV2';
import SolidButton from './Solid';
import LoadingToCart from './LoadingToCart';
import SwiperPreviousButton from './SwiperPreviousButton';
import SwiperNextButton from './SwiperNextButton';
import ModalSwipeCloseButton from './ModalSwipeCloseButton';

function Button(props) {
  const { type, ...rest } = props;

  switch (type) {
    case 'primary':
      return <Primary {...rest} />;
    case 'outline':
      return <Outline {...rest} />;
    case 'add-to-cart':
      return <AddToCart {...rest} />;
    case 'loading-to-cart':
      return <LoadingToCart {...rest} />;
    case 'see-details':
      return <SeeDetails {...rest} />;
    case 'out-of-stock':
      return <OutOfStock {...rest} />;
    case 'view-3d':
      return <View3D {...rest} />;
    case 'link':
      return <Link {...rest} />;
    case 'go-back':
      return <GoBack {...rest} />;
    case 'go-back-small':
      return <GoBackSmall {...rest} />;
    case 'explore-all-deals':
      return <ExploreAllDeals {...rest} />;
    case 'outline-v2':
      return <OutlineButtonV2 {...rest} />;
    case 'solid':
      return <SolidButton {...rest} />;
    case 'swiper-previous-button':
      return <SwiperPreviousButton {...rest} />;
    case 'swiper-next-button':
      return <SwiperNextButton {...rest} />;
    case 'modal-swipe-close-button':
      return <ModalSwipeCloseButton {...rest} />;
    default:
      return '';
  }
}

export default Button;
